import { render, staticRenderFns } from "./AlertIgnoreAddress.vue?vue&type=template&id=69e7846a"
import script from "./AlertIgnoreAddress.vue?vue&type=script&lang=js"
export * from "./AlertIgnoreAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports